import { Injectable, OnDestroy } from '@angular/core';
import {
  ServicingSeatmapStore,
  selectServicingSeatmapState,
  setServicingSeatmap,
  updateServicingSeatmap,
} from '@common/store/servicing-seatmap';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SeatmapStoreModel } from '@common/interfaces/servicing-seatmap/seatmap-store-model';

@Injectable({
  providedIn: 'root',
})
export class ServicingSeatmapStoreService implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _servicingSeatmap$: Observable<SeatmapStoreModel>;
  private _servicingSeatmap: SeatmapStoreModel = {};
  public get servicingSeatmap(): SeatmapStoreModel {
    return this._servicingSeatmap;
  }
  constructor(private _store: Store<ServicingSeatmapStore>) {
    this._servicingSeatmap$ = this._store.pipe(
      select(selectServicingSeatmapState),
      map((state) => state.model || {})
    );
    this._subscriptions.push(
      this._servicingSeatmap$.subscribe((data) => {
        this._servicingSeatmap = data;
      })
    );
  }

  /**
   * サービシングシートマップStoreのモデルを取得するObservableを取得
   * @returns サービシングシートマップStoreのモデルを取得するObservable
   */
  public getServicingSeatmapModel$(): Observable<SeatmapStoreModel> {
    return this._servicingSeatmap$;
  }

  /**
   * サービシングシートマップStoreを指定された状態に上書きする
   * @param model 上書きを行うModel
   */
  public setServicingSeatmap(model: SeatmapStoreModel) {
    this._store.dispatch(setServicingSeatmap({ model }));
  }

  /**
   * サービシングシートマップStoreの指定されたパラメータを更新する
   * @param model 更新を行うModel
   */
  public updateServicingSeatmap(model: SeatmapStoreModel) {
    this._store.dispatch(
      updateServicingSeatmap({
        model: {
          ...this._servicingSeatmap,
          ...model,
        },
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions
      .filter((subscription) => subscription != null)
      .forEach((subscription) => subscription.unsubscribe());
  }
}
